import React from "react";
import { Link } from "react-router-dom";
import AmenityBox from "../AmenityBox";
import Button from "components/UI/Button";

const amenitiesEdit = (gymAmenities, deleteAmenitiy, addBtn) => {
  return gymAmenities.map((currentItem, index, arr) => {
    const classname = currentItem.class_name;
    const classid = currentItem.class_id;
    const isPrimaryAmenity = currentItem.is_primary_amenity;
    const classAmenities = currentItem.amenities.map(currentItem => (
      <div style={{ margin: "10px" }}>
        <AmenityBox
          edit
          label={currentItem.name}
          source={currentItem.icons.black}
          onXClick={() => {
            deleteAmenitiy(currentItem.id, isPrimaryAmenity);
          }}
        />
      </div>
    ));
    const showAddButton = isPrimaryAmenity ? classAmenities.length === 0 : true
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h2>{classname}</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)" }}>
          {classAmenities}
          {showAddButton && <AmenityBox
            label={"Add Item"}
            onClick={() => {
              addBtn(classid, isPrimaryAmenity);
            }}
          />}
        </div>
      </div>
    );
  });
};

const Edit = props => {
  const style = {
    Button: {
      width: "200px"
    },
    amenitiesWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flexWrap: "wrap",
      marginTop: "20px"
    },
    buttonWrapper: {
      display: "flex",
      justifyContent: "flex-start"
    }
  };
  return (
    <div>
      <div style={style.buttonWrapper}>
        <Link to="/gyms/gym/amenities/">
          <Button type="primary" style={style.Button}>
            Save
          </Button>
        </Link>
      </div>
      <div style={style.amenitiesWrapper}>
        {amenitiesEdit(props.gymAmenities, props.deleteAmenitiy, props.addBtn)}
      </div>
    </div>
  );
};

export default Edit;
